import config from '../../config';

export const phoneOperatorValidate = (phone: string) => {
  const { phoneOperatorFormat } = config;
  const opCode = phone.slice(0, 3);

  return opCode.match(phoneOperatorFormat);
};
